import React from 'react';
import { Bloodwork } from '../../models/Bloodwork';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from "highcharts/highcharts-more";
import SolidGuage from "highcharts/modules/solid-gauge";
import { ProbabilityCategory } from '../../models/ProbabilityCategory';
HighchartsMore(Highcharts);
SolidGuage(Highcharts);

type Props = {
    chartContainerId: string;
    bloodwork: Bloodwork;
    text: string;
    probability: number;
    category: ProbabilityCategory;
    /** Score values to label on the arc (e.g. zone boundaries). Off by default. */
    ticks?: number[];
};

type State = {
    bloodwork: Bloodwork;
}

export class LabsmartsGuage extends React.Component<Props, State> {
    componentWillReceiveProps(nextProps) {
        this.setState({
            bloodwork: nextProps.bloodwork
        });
    }

    createOptions() {
        const { bloodwork, text, probability, category, ticks } = this.props;

        if (!bloodwork) {
            return null;
        }

        const showTicks = !!(ticks && ticks.length);
    
        const GREEN = '#78F880';
        const YELLOW = '#FEFA83';
        const ORANGE = '#FFD37E';
        const RED = '#FC6552';
        const options: Highcharts.Options = {
            title: null,
            chart: {
                type: 'solidgauge',
                height: 200,
                width: 260,
                margin: [-20, 0, -40, 0],
                backgroundColor: null
            },
            pane: {
                center: ['50%', '60%'],
                size: '100%',
                startAngle: -90,
                endAngle: 90,
                background: [{
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                }]
            },
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                // No tick dashes anywhere — major OR minor — just the number labels
                // at the zone boundaries. (tickWidth:0 alone leaves minor ticks drawn.)
                tickWidth: 0,
                tickLength: 0,
                minorTickWidth: 0,
                minorTickLength: 0,
                // Numbers sit just inside the colored ring, so they never widen the
                // 260px chart the way outside labels (0 / 100 at the arc ends) would.
                tickPositions: showTicks ? ticks : [],
                labels: {
                    enabled: showTicks,
                    distance: -15,
                    style: { fontSize: '10.5px', color: '#3a3a3a', fontWeight: '600', textOutline: '2px #ffffff' },
                },
                plotBands: [{
                    color: GREEN,
                    from: 0,
                    to: 50,
                    innerRadius: '60%',
                    outerRadius: '100%',
                },
                {
                    color: YELLOW,
                    from: 50,
                    to: 70,
                    innerRadius: '60%',
                    outerRadius: '100%',
                },
                {
                    color: ORANGE,
                    from: 70,
                    to: 90,
                    innerRadius: '60%',
                    outerRadius: '100%',
                },
                {
                    color: RED,
                    from: 90,
                    to: 100,
                    innerRadius: '60%',
                    outerRadius: '100%',
                }]
            },
            series: [{
                type: 'gauge',
                data: [probability],
                dataLabels: {
                    useHTML: true,
                    format: `<div class="anemiaStatusGuageLabelContainer">${text}<br/>
                                <div class="anemiaStatusGuageLabel">
                                    ${category} (${probability}%)
                                </div>
                             </div>`,
                    borderWidth: 0
                }
            }],
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            }
        };
        return options;
    }

    render() {
        const { chartContainerId } = this.props;

        return (
            <HighchartsReact 
                highcharts={Highcharts}
                options={this.createOptions()}
                containerProps = { { id: chartContainerId } }
            />
        );
    }
}